export const hasReloaded = 'has-reloaded';
